/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'milvus.title',
    defaultMessage: 'Milvus'
  },
  connect: {
    id: 'milvis.connect',
    defaultMessage: 'Connect Milvus'
  },
  index: {
    id: 'milvis.index',
    defaultMessage: 'Select data source'
  },
  search: {
    id: 'milvis.search',
    defaultMessage: 'Conversational search (optional)'
  },
  close: {
    id: 'milvis.close',
    defaultMessage: 'Close'
  },
  save: {
    id: 'milvis.save',
    defaultMessage: 'Save'
  },
  next: {
    id: 'milvis.next',
    defaultMessage: 'Next'
  },
  finish: {
    id: 'milvis.finish',
    defaultMessage: 'Finish'
  },
  configHeading: {
    id: 'milvusConfig.configHeading',
    defaultMessage: 'Connect your search provider'
  },
  urlLabelText: {
    id: 'milvusConfig.urlLabelText',
    defaultMessage: 'GRPC host'
  },
  urlPlaceholder: {
    id: 'milvusConfig.urlPlaceholder',
    defaultMessage: 'exampleUrl.com'
  },
  portLabelText: {
    id: 'milvusConfig.portLabelText',
    defaultMessage: `GRPC port (required)`
  },
  portPlaceholder: {
    id: 'milvusConfig.portPlaceholder',
    defaultMessage: `19530`
  },
  invalidPort: {
    id: 'milvusConfig.invalidPort',
    defaultMessage: `Invalid port number entered`
  },
  authTypeLabelText: {
    id: 'milvusConfig.authTypeLabelText',
    defaultMessage: 'Choose an authentication type'
  },
  usernameLabelText: {
    id: 'milvusConfig.usernameLabelText',
    defaultMessage: 'Username'
  },
  usernamePlaceholder: {
    id: 'milvusConfig.usernamePlaceholder',
    defaultMessage: 'exampleUser'
  },
  passwordLabelText: {
    id: 'milvusConfig.passwordLabelText',
    defaultMessage: 'Password'
  },
  apiKeyLabelText: {
    id: 'milvusConfig.apiKeyLabelText',
    defaultMessage: 'API key'
  },
  invalidEmptyValueText: {
    id: 'milvusConfig.invalidEmptyValueText',
    defaultMessage: `Value can't be empty.`
  },
  invalidUrlValueText: {
    id: 'milvusConfig.invalidUrlValueText',
    defaultMessage: `Value must be a valid url, ex. "https://www.example.com".`
  },
  authTypeAPIkeyText: {
    id: 'milvusConfig.authTypeAPIkeyText',
    defaultMessage: 'watsonx.data API key'
  },
  authTypeBasicText: {
    id: 'milvusConfig.authTypeBasicText',
    defaultMessage: 'Basic authentication'
  },
  authTypeNoneText: {
    id: 'milvusConfig.authTypeNoneText',
    defaultMessage: 'None'
  },
  update: {
    id: 'milvusConfig.update',
    defaultMessage: 'Update'
  },
  description: {
    id: 'milvusConfig.description',
    defaultMessage:
      'Fill in the information below to access your Milvus instance. '
  },
  learnMore: {
    id: 'milvusConfig.description',
    defaultMessage: 'Learn more'
  }
});

export const MilvusDataSourceMessages = defineMessages({
  title: {
    id: 'milvusDataSource.title',
    defaultMessage: 'Select data source'
  },
  database: {
    id: 'milvusDataSource.database',
    defaultMessage: 'Database'
  },
  collection: {
    id: 'milvusDataSource.collection',
    defaultMessage: 'Choose collection'
  },
  index: {
    id: 'milvusDataSource.index',
    defaultMessage: 'Choose index'
  },
  modelId: {
    id: 'milvusDataSource.modelId',
    defaultMessage: 'Choose embedding_model_id'
  },
  selectOne: {
    id: 'milvusDataSource.selectOne',
    defaultMessage: 'Select one'
  },
  fieldTitle: {
    id: 'milvusDataSource.fieldTitle',
    defaultMessage: 'Title'
  },
  fieldBody: {
    id: 'milvusDataSource.fieldBody',
    defaultMessage: 'Body'
  },
  fieldUrl: {
    id: 'milvusDataSource.fieldUrl',
    defaultMessage: 'URL (optional)'
  },
  contentTitle: {
    id: 'ConfigureContentMessages.contentTitle',
    defaultMessage: 'Configure result content'
  },
  description: {
    id: 'milvusDataSource.description',
    defaultMessage:
      'Specify the {name} fields you want to map to the title, body, and URL of the search response.'
  }
});

export const MilvusTabsMessages = defineMessages({
  settings: {
    id: 'milvusTabs.settings',
    defaultMessage: 'Settings'
  },
  instance: {
    id: 'milvusTabs.instance',
    defaultMessage: 'Instance'
  }
});
